import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Firestore pages only say whether a next page exists, not the total, so until the last page the range label
 * drops the "of N" part ("21 – 40" instead of a misleading "21 – 40 of 41").
 */
@Injectable()
export class OrderRequestsPaginatorIntl extends MatPaginatorIntl {
  private totalKnown = true;
  // Captured before the override below replaces it (fields initialize in declaration order).
  private readonly defaultRangeLabel = this.getRangeLabel;

  setTotalKnown(totalKnown: boolean): void {
    if (this.totalKnown !== totalKnown) {
      this.totalKnown = totalKnown;
      this.changes.next();
    }
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (this.totalKnown) {
      return this.defaultRangeLabel(page, pageSize, length);
    }
    if (length === 0) {
      return '0';
    }
    const start = page * pageSize;
    return `${start + 1} – ${Math.min(start + pageSize, length)}`;
  };
}
